import { Stack, Text, Box } from '@ltvco/refresh-lib/theme';
import {
  capitalizeString,
  commaFormat,
  commaFormatCurrency,
} from '@ltvco/refresh-lib/utils';

import { PropertySummaryData } from '../DataTypes/SummaryTypes';

import { BoldSpan } from './components';

interface PropertyReportRendererProps {
  data: PropertySummaryData;
}

export const PropertyReportRenderer = ({
  data,
}: PropertyReportRendererProps) => {
  return (
    <Stack spacing={2}>
      {data.address && (
        <Text variant="body1">
          Here are the details for the property located at:{' '}
          <BoldSpan>{data.address}</BoldSpan>
        </Text>
      )}
      <Stack spacing={1.5}>
        <Box>
          <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
            Property Overview:
          </Text>
          <Text variant="body1">
            <BoldSpan>🏠 Property:</BoldSpan> {data.property_type || 'N/A'} |
            Built {data.year_built || 'N/A'} | {data.bedrooms || 'N/A'} beds |{' '}
            {data.bathrooms || 'N/A'} baths |{' '}
            {data.square_footage
              ? commaFormat(Number(data.square_footage))
              : 'N/A'}{' '}
            sq ft
            {data.lot_size &&
              ` | Lot: ${commaFormat(Number(data.lot_size))} Sq Ft`}
          </Text>
        </Box>

        {(data.estimated_value || data.taxes) && (
          <Box>
            <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
              💰 Financials:
            </Text>
            <Text variant="body1">
              {data.estimated_value &&
                `Estimated Value ${commaFormatCurrency(
                  Number(data.estimated_value)
                )}`}
              {data.estimated_value && data.taxes && ' | '}
              {data.taxes &&
                `${data.tax_year} Taxes ${commaFormatCurrency(
                  Number(data.taxes)
                )}`}
            </Text>
          </Box>
        )}
        <Box>
          <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
            Owner(s):
          </Text>
          {data.owners?.map((owner, index) => (
            <Box key={owner.names?.[0]?.full ?? index}>
              <Text variant="body2">
                <strong>Name:</strong>{' '}
                {capitalizeString(owner.names?.[0]?.full)}
              </Text>
            </Box>
          ))}
        </Box>
      </Stack>
    </Stack>
  );
};
